<script setup lang="ts">
defineProps<{ name: string }>()
</script>

<template>
  <div class="min-w-[230px]">
    <div class="block">
      <div class="w-full">
        <h4
          class="mb-3 border-b-[3px] border-p-500 pb-3 font-montserrat text-sm font-semibold uppercase text-s-900 xl:text-base xl:leading-5"
        >
          {{ name }}
        </h4>

        <div class="flex flex-row gap-x-3">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
